import { WinCounter } from '@/managers/winning/WinCounter'
import { toMoney } from '@base/utils/Formatter'
import gsap from 'gsap'
import * as PIXI from 'pixi.js'

interface TextContainer {
    text: string
}

export class TweenUtils {
    public static bounceScale(object: PIXI.DisplayObject, duration: { in: number, out: number }, scale: { x: number, y: number }, ease: { in: string, out: string } ): void {
        const timeline = gsap.timeline()
        const initScale = {
            x: object.scale.x,
            y: object.scale.y
        }
        timeline.fromTo(object.scale, duration.in, { x: initScale.x, y: initScale.y, ease: ease.in }, { x: initScale.x * scale.x, y: initScale.y * scale.y, ease: ease.in })
        timeline.to(object.scale, duration.out, { x: initScale.x, y: initScale.y, ease: ease.out })
    }

    public static bounceDown(object: PIXI.DisplayObject, duration: number, from: number, to: number): void {
        const timeline = gsap.timeline()

        timeline.to(object, { duration: duration, y: from + to })
        .to(object, { duration: duration, y: from })
    }

    public static countValue(object: TextContainer, startValue: number, targetValue: number, duration: number = WinCounter.DURATION): void {
        const counter = { value: startValue }

        gsap.to(
            counter, duration, {
                value: targetValue,
                ease: WinCounter.EASING,
                onUpdate: () => {
                    object.text = toMoney(counter.value, 2)
                },
            },
        )
    }

    public static fadeIn(object: PIXI.DisplayObject, duration: number, delay: number = 0): void {
        gsap.killTweensOf(object)
        gsap.fromTo(object, duration, { alpha: 0 }, { alpha: 1, delay })
        object.visible = true
    }

    public static fadeOut(object: PIXI.DisplayObject, duration: number, delay: number = 0): void {
        gsap.killTweensOf(object)
        gsap.fromTo(object, duration, { alpha: 1 }, { alpha: 0, delay, onComplete: () => object.visible = false })
        object.visible = true
    }
}
